import styles from "./Filters.module.scss";
import { TRANSPARENT_KEY, needsOutline, swatchFor } from "./colors";

interface Props {
  value: string;
}

export default function ColorSwatch({ value }: Props) {
  const isTransparent = value.toUpperCase() === TRANSPARENT_KEY;

  return (
    <span
      aria-hidden="true"
      className={[
        styles.swatch,
        isTransparent ? styles.swatchTransparent : "",
        needsOutline(value) ? styles.swatchOutlined : "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={isTransparent ? undefined : { background: swatchFor(value) }}
    />
  );
}
